import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type SignalCorrelationAnalysisProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;
  title: string;

  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'signal_correlation_analysis', string>;
};

const SignalCorrelationAnalysis = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  mode,
  params,
  setParams,
  fullScreen,
  title,
}: SignalCorrelationAnalysisProps) => {
  const chart = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths?.['signal_correlation_analysis'] ?? ''}
      fullScreen={fullScreen}
      title={title}
    />
  );

  return <>{mode === 'edit' ? <Form params={params} setParams={setParams} /> : chart()}</>;
};

export default SignalCorrelationAnalysis;
